import React from 'react';
import Dim from 'web/components/common/modal/common/Dim';
import Coupon from 'shared/components/popup/coupon/Coupon';
import { initModal, pushModal } from 'shared/actions/modal.action';
import { useSelector, useDispatch } from 'react-redux';
import { postCoupon } from 'shared/actions/coupon.action';
import storage from 'shared/utils/storage';

function CouponContainer({ data, location }) {
  const dispatch = useDispatch();
  const { couponInfo } = useSelector(state => state.shared.coupon);
  const { user } = useSelector(state => state.shared.auth);
  /**
   * 쿠폰 클릭해서 받아오기
   */
  const getCoupon = () => {
    if (user.type === 'GUEST') {
      // 로그인 후 쿠폰 발급을 위해 저장
      // storage.set('welcome:coupon', couponInfo.couponNumber);
      storage.set('welcome:coupon', couponInfo.codeMD5);
      dispatch(pushModal({ type: 'Login' }));
    } else {
      // 이미 로그인 된 유저라면 바로 발급 진행
      // dispatch(postCoupon(couponInfo.couponNumber));
      dispatch(postCoupon(couponInfo.codeMD5));
    }
  };

  const handleClose = () => {
    dispatch(initModal());
  };

  return (
    <Dim>
      <Coupon
        image={couponInfo.useBeforeImageUrl}
        handleClick={getCoupon}
        handleClose={handleClose}
        couponInfo={couponInfo}
        text="쿠폰 받기"
      />
    </Dim>
  );
}

export default CouponContainer;
